// extracted by mini-css-extract-plugin
module.exports = {"diffTitle":"LinkClaimDiff_diffTitle__2if13","claimDiffContainer":"LinkClaimDiff_claimDiffContainer__oxTHQ"};